import { Serializable } from '@/models/core/serializable';

export class Trend implements Serializable<Trend> {
  trendID: number;
  masterID: number;
  tested: boolean;
  title: string;
  score: number;
  highScoreTitle: string;
  lowScoreTitle: string;

  deserialize(input: any): Trend {
    this.trendID = input.trendID;
    this.masterID = input.masterID;
    this.tested = input.tested;
    this.title = input.title;
    this.highScoreTitle = input.highScoreTitle;
    this.lowScoreTitle = input.lowScoreTitle;
    return this;
  }
  get iconUrl(): string {
    return 'iconUrl'; // 暫定対応
    // TODO iconが決まったら差し替え
    // return require(`@/assets/image/trend_hr_icon${this.masterID}.svg`);
  }
}
